import React from 'react';
import Projects from '../components/sections/Projects';
import styled from 'styled-components';

const ProjectsPage = () => {
    return (
        <PageContainer>
            <Projects />
        </PageContainer>
    );
};

const PageContainer = styled.div`
  padding-top: 80px; // To account for fixed header
`;

export default ProjectsPage;
